import can from 'can';
import urlUtil from 'scripts/utils/url';
import Modernizr from 'modernizr';
import {CategoryPlaylist, Playlist} from 'scripts/utils/playlist';

const VideoDetailModelMap = can.Map.extend({
    define: {
        categories: {
            Type: can.List,
            Value: can.List,
        },
        playlistPosition: {
            Type: Number,
            Value: 0
        },
        allPlaylists: {
            Type: can.List,
            Value: can.List,
        },
        activeCard: {
            Type: can.Map,
            Value: null
        },
        videoCarouselCards: {
            Type: can.Map,
            Value: null
        },
        videoCards: {
            Type: can.List,
            Value: can.List
        },
        dtmTrack: {
            type: 'boolean',
            value: false
        },
        dtmVideoLocation: {
            type: 'string',
            value: 'Video Detail Page'
        }
    },
    getId: (() => {
        let id = 0;
        return () => id++;
    })(),
    initPlaylists () {
        can.batch.start();

        const allPlaylists = this.attr('allPlaylists');

        const brightcoveId = urlUtil.getHashValue('brightcoveId');
        const pageTitle = decodeURIComponent(urlUtil.getHashValue('pageTitle'));
        const playlistType = decodeURIComponent(urlUtil.getHashValue('playlist'));

        if (playlistType === 'unknown' && brightcoveId) {
            const pl = new Playlist({
                id: this.getId(),
                type: 'unknown',
                videos: [{
                    brightcoveId,
                    pageTitle
                }],
                count: 1
            });
            allPlaylists.push(pl);
            this.attr('activePlaylist', pl);
        }

        this.attr('categories').map((cat) => {
            const type = cat.attr('value');
            const pl = new CategoryPlaylist({
                id: this.getId(),
                type,
            });
            cat.attr('playlist', pl);
            if (type === playlistType) {
                this.attr('activePlaylist', pl);
            }
            allPlaylists.push(pl);
        });

        this.attr('playlists').each((customPl, name) => {
            const pl = new Playlist({
                id: this.getId(),
                type: name,
                videos: customPl,
                count: customPl.length
            });
            if (name === playlistType) {
                this.attr('activePlaylist', pl);
            }
            if (!this.attr('playlistPosition')) {
                this.attr('categories').push({
                    text: name,
                    value: name,
                    playlist: pl
                });
                allPlaylists.push(pl);
            } else {
                this.attr('categories').splice(this.attr('playlistPosition') - 1, 0, {
                    text: name,
                    value: name,
                    playlist: pl
                });
                allPlaylists.splice(this.attr('playlistPosition') - 1, 0, pl);
            }
        });

        if (brightcoveId) {
            if (!this.attr('activePlaylist')) {
                console.warn('Playlist not set');
            } else {
                this.attr('activePlaylist').setVideoById(brightcoveId, pageTitle);
            }
        }
        can.batch.stop();
    },
    initCarousel () {
        can.batch.start();

        const playlistType = urlUtil.getHashValue('playlist');
        const videos = this.attr('videoCarouselCards');
        const carouselPlaylist = new Playlist({
            id: this.getId(),
            type: 'carousel',
            videos,
            count: videos.length
        });
        this.attr('allPlaylists').unshift(carouselPlaylist);
        this.attr('videoCarouselPlaylist', carouselPlaylist);


        if (playlistType === 'carousel' || !this.attr('activePlaylist.type')) {
            this.attr('activePlaylist', carouselPlaylist);
            Modernizr.on('videoautoplay', (autoplay) => {
                if (autoplay) {
                    carouselPlaylist.setVideo(0);
                }
            })
        }

        can.batch.stop();
    }
});

export const VideoDetailModel = new VideoDetailModelMap();
